
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    isTwoColumns: {
      type: Boolean,
    },
  },
});
